var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/auth/InsuletConnection/index.tsx";
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { usePartner } from 'Hooks';
import { LogoActionBar, Main, Spinner } from 'Components/utility';
import { redirect } from 'Utilities/browser';
import { getAuthSession } from 'Utilities/session';
import { clearSession } from 'Utilities/storage';
import { createConnection } from 'Services/insulet';
const mapStateToProps = ({
  env: {
    redirect_uri
  }
}) => {
  return {
    redirect_uri
  };
};
const connector = connect(mapStateToProps);
const InsuletConnection = ({
  redirect_uri
}) => {
  const {
    handleUnexpectedError
  } = usePartner();
  useEffect(() => {
    const initializeConnection = async () => {
      try {
        const authSession = getAuthSession();
        if (authSession) {
          const {
            cid,
            accountId,
            accessToken
          } = authSession;
          const redirectUrl = await createConnection(cid, redirect_uri, accountId, accessToken);
          redirect(redirectUrl);
          clearSession();
          return;
        }
        handleUnexpectedError();
      } catch (err) {
        handleUnexpectedError();
      }
    };
    initializeConnection();
  }, [handleUnexpectedError, redirect_uri]);
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(LogoActionBar, {
    testID: "Connection",
    noActionButton: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Spinner, {
    testID: "Connection",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 7
    }
  }));
};
export default connector(InsuletConnection);